/**
 * 组件里面注册控件用vuec
 * * 1: // 文本类
 * * 2://数字组件
 * * 3://日期选择组件
 * * 4://文本域组件
 * * 5://富文本
 * * 6://单选组件
 * * 7://复选组件
 * * 8://图片控件
 * * 9://附件组件(包含图片、音频、视频)
 * * 10://下拉框组件
 * * 13://系统字典组件
 * * 17: // 区域
 * * 21://机构字典组件
 */
import { shallowRef } from 'vue'
import ElText from '../base/t-text.vue'
import ElNumber from '../base/t-number.vue'
import ElDate from '../base/t-date.vue'
import ElTextArea from '../base/t-textarea.vue'
import ElRichText from '../base/t-richtext.vue'
import ElRadio from '../base/s-radio.vue'
import ElCheckbox from '../base/s-checkbox.vue'
import ElImage from '../base/f-image.vue'
import ElFile from '../base/f-multiple.vue'
import ElDropDown from '../base/s-select.vue'
import ElArea from '../base/s-area.vue'
import ElDict from '../base/s-dict.vue'

const formItemList = {
  elText: shallowRef(ElText),
  elNumber: shallowRef(ElNumber),
  elDate: shallowRef(ElDate),
  elTextArea: shallowRef(ElTextArea),
  elRichText: shallowRef(ElRichText),
  elRadio: shallowRef(ElRadio),
  elCheckBox: shallowRef(ElCheckbox),
  elImage: shallowRef(ElImage),
  elFile: shallowRef(ElFile),
  elDropDown: shallowRef(ElDropDown),
  elSdict: shallowRef(ElDict),
  elArea: shallowRef(ElArea)
}
/**
 * 动态组件的字典，便于v-for循环里面设置控件
 */
export const formItemListKey = {
  1: formItemList['elText'], // 文本类
  2: formItemList['elNumber'], //数字组件
  3: formItemList['elDate'], //日期选择组件
  4: formItemList['elTextArea'], //文本域组件
  5: formItemList['elRichText'], //富文本组件
  6: formItemList['elRadio'], //单选组件
  7: formItemList['elCheckBox'], //复选组件
  8: formItemList['elImage'], //图片控件
  9: formItemList['elFile'], //附件组件(包含图片、音频、视频)
  10: formItemList['elDropDown'], //下拉框组件
  13: formItemList['elSdict'], //系统字典组件
  17: formItemList['elArea'], // 区域
  21: formItemList['elSdict'] //机构字典组件
}
